import Vue from 'vue';

Vue.directive('tooltip', {
    bind(el, binding) {
        const trigger = 'hover focus';

        $(el).tooltip({
            title: binding.value,
            placement: binding.arg,
            trigger: trigger,
            html: !!binding.modifiers.html
        })
    },

    update(el, binding) {
        $(el).attr('data-original-title', binding.value).tooltip();
    },

    unbind(el, binding) {
        $(el).tooltip('dispose');
    }
});
